import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { TarGZipCompressionReadSettings } from 'app/model/pipeline/copysource/compression-read-settings/tar-gzip-compression-read-settings';
import { compressionReadSettingsAdapts, CompressionReadSettingsAdapter } from './compression-read-settings.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TarGZipCompressionReadSettings),
    asynchronous: true,
    adapts: {
        ...compressionReadSettingsAdapts,
        preserveCompressionFileNameAsFolder: '*'
    }
})
export class TarGZipCompressionReadSettingsAdapter extends CompressionReadSettingsAdapter<
    TarGZipCompressionReadSettings,
    Model.CompressionReadSettings
> {
    protected override async _toResource(
        model: TarGZipCompressionReadSettings
    ): Promise<Model.CompressionReadSettings> {
        const result: Model.CompressionReadSettings =
            CompressionReadSettingsAdapter.getCommonCompressionReadSettingsProperties(
                Metamodel.modelFor(TarGZipCompressionReadSettings).name
            );
        result.preserveCompressionFileNameAsFolder = ValueAdapter.toResource(
            model,
            TarGZipCompressionReadSettings.PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER
        );
        return result;
    }

    protected override async _toModel(
        resource: Model.CompressionReadSettings,
        formatReadSettings: FormatReadSettings
    ): Promise<TarGZipCompressionReadSettings> {
        const result = CompressionReadSettingsAdapter.createCompressionReadSettingsWithCommonProperties(
            TarGZipCompressionReadSettings.MODEL,
            formatReadSettings
        ) as TarGZipCompressionReadSettings;
        ValueAdapter.toModel(
            result,
            TarGZipCompressionReadSettings.PRESERVE_COMPRESSIONFILE_NAME_AS_FOLDER,
            resource.preserveCompressionFileNameAsFolder
        );
        return result;
    }
}
